export default "__VITE_ASSET__f19b020d__"